/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Happy_Magenta_Camel_FlyInputs */

const en_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request more activations`)
};

const id_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minta aktivasi tambahan`)
};

const ms_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minta lebih banyak pengaktifan`)
};

const ca_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sol·licita més activacions`)
};

const cs_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Požádat o další aktivace`)
};

const da_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmod om flere aktiveringer`)
};

const de_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitere Aktivierungen anfordern`)
};

const et_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taotle rohkem aktiveerimisi`)
};

const es_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitar más activaciones`)
};

const fr_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demander des activations supplémentaires`)
};

const hr_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatraži više aktivacija`)
};

const it_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Richiedi più attivazioni`)
};

const lv_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pieprasīt vairāk aktivizāciju`)
};

const lt_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prašyti daugiau aktyvavimų`)
};

const hu_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`További aktiválások kérése`)
};

const nl_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meer activeringen aanvragen`)
};

const nb_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Be om flere aktiveringer`)
};

const pl_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poproś o więcej aktywacji`)
};

const pt_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitar mais ativações`)
};

const ro_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicită mai multe activări`)
};

const sk_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Požiadať o ďalšie aktivácie`)
};

const sl_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahtevaj več aktivacij`)
};

const fi_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pyydä lisää aktivointeja`)
};

const sv_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begär fler aktiveringar`)
};

const vi_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yêu cầu thêm lượt kích hoạt`)
};

const tr_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daha fazla etkinleştirme talep et`)
};

const el_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αίτηση για περισσότερες ενεργοποιήσεις`)
};

const bg_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заявка за повече активирания`)
};

const ru_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запросить больше активаций`)
};

const sr_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Затражите више активација`)
};

const uk_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запросити більше активацій`)
};

const ka_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`მოითხოვეთ მეტი გააქტიურება`)
};

const hi_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अधिक सक्रियण का अनुरोध करें`)
};

const th_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ขอการเปิดใช้งานเพิ่มเติม`)
};

const ko_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`추가 활성화 요청`)
};

const zh_tw_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`申請更多啟用次數`)
};

const ja_happy_magenta_camel_fly = /** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追加のアクティベーションをリクエスト`)
};

/** @type {(inputs: Happy_Magenta_Camel_FlyInputs) => LocalizedString} */
const zh_happy_magenta_camel_fly = en_happy_magenta_camel_fly;

/**
* | output |
* | --- |
* | "Request more activations" |
*
* @param {Happy_Magenta_Camel_FlyInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const happy_magenta_camel_fly = /** @type {((inputs?: Happy_Magenta_Camel_FlyInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Happy_Magenta_Camel_FlyInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_happy_magenta_camel_fly(inputs)
	if (locale === "ms") return ms_happy_magenta_camel_fly(inputs)
	if (locale === "ca") return ca_happy_magenta_camel_fly(inputs)
	if (locale === "cs") return cs_happy_magenta_camel_fly(inputs)
	if (locale === "da") return da_happy_magenta_camel_fly(inputs)
	if (locale === "de") return de_happy_magenta_camel_fly(inputs)
	if (locale === "et") return et_happy_magenta_camel_fly(inputs)
	if (locale === "es") return es_happy_magenta_camel_fly(inputs)
	if (locale === "fr") return fr_happy_magenta_camel_fly(inputs)
	if (locale === "hr") return hr_happy_magenta_camel_fly(inputs)
	if (locale === "it") return it_happy_magenta_camel_fly(inputs)
	if (locale === "lv") return lv_happy_magenta_camel_fly(inputs)
	if (locale === "lt") return lt_happy_magenta_camel_fly(inputs)
	if (locale === "hu") return hu_happy_magenta_camel_fly(inputs)
	if (locale === "nl") return nl_happy_magenta_camel_fly(inputs)
	if (locale === "nb") return nb_happy_magenta_camel_fly(inputs)
	if (locale === "pl") return pl_happy_magenta_camel_fly(inputs)
	if (locale === "pt") return pt_happy_magenta_camel_fly(inputs)
	if (locale === "ro") return ro_happy_magenta_camel_fly(inputs)
	if (locale === "sk") return sk_happy_magenta_camel_fly(inputs)
	if (locale === "sl") return sl_happy_magenta_camel_fly(inputs)
	if (locale === "fi") return fi_happy_magenta_camel_fly(inputs)
	if (locale === "sv") return sv_happy_magenta_camel_fly(inputs)
	if (locale === "vi") return vi_happy_magenta_camel_fly(inputs)
	if (locale === "tr") return tr_happy_magenta_camel_fly(inputs)
	if (locale === "el") return el_happy_magenta_camel_fly(inputs)
	if (locale === "bg") return bg_happy_magenta_camel_fly(inputs)
	if (locale === "ru") return ru_happy_magenta_camel_fly(inputs)
	if (locale === "sr") return sr_happy_magenta_camel_fly(inputs)
	if (locale === "uk") return uk_happy_magenta_camel_fly(inputs)
	if (locale === "ka") return ka_happy_magenta_camel_fly(inputs)
	if (locale === "hi") return hi_happy_magenta_camel_fly(inputs)
	if (locale === "th") return th_happy_magenta_camel_fly(inputs)
	if (locale === "ko") return ko_happy_magenta_camel_fly(inputs)
	if (locale === "zh") return zh_happy_magenta_camel_fly(inputs)
	if (locale === "zh-tw") return zh_tw_happy_magenta_camel_fly(inputs)
	if (locale === "ja") return ja_happy_magenta_camel_fly(inputs)
	return en_happy_magenta_camel_fly(inputs)
});